import clsx from 'clsx';
import React from 'react';
import styles from './index.css';

export default React.memo(function TwoDashes({ bold = false }: { bold?: boolean }) {
    return <div className={clsx(styles.dash, bold && styles.bold)}>--</div>;
});
